import { AugmentationPanelItemProps } from "@pathwright/ux/src/components/augmentation/AugmentationPanelSection"
import { isEmpty } from "@pathwright/ux/src/components/texteditor/utils"
import { useMemo } from "react"
import { RESOURCE_TYPE_COLLECTION } from "../../resource/constants"
import { useCoverPageContext } from "../CoverPageProvider"
import { CoverPagePanelSection } from "../types"
import { useCoverPageTranslate } from "../utils"
import { requestCoverPageInlineSectionEdit } from "./CoverPageInlineSectionEditor"
import { CoverPagePanelSectionBlock } from "./CoverPagePanelSection"
import { useCoverPageAddLabel } from "./addLabels"

export function CoverPagePanelPitchSection() {
  const resource = useCoverPageContext((value) => value.resource)
  const designPanelDisclosure = useCoverPageContext(
    (value) => value.designPanelDisclosure
  )
  const { t } = useCoverPageTranslate()
  const addOverviewLabel = useCoverPageAddLabel("overview")
  const addPreviewLabel = useCoverPageAddLabel("preview")
  const isCollection = resource?.resource_type === RESOURCE_TYPE_COLLECTION

  const items: AugmentationPanelItemProps[] = useMemo(
    () => [
      {
        itemKey: "edit-title-images",
        icon: "image",
        label: t("panel_pitch.edit_title_images", {
          defaultValue: "Edit header title, images..."
        }),
        panelRoute: "/header"
      },
      {
        itemKey: "edit-description",
        icon: "edit",
        label: !isEmpty(resource?.description)
          ? t("panel_pitch.edit_overview", { defaultValue: "Edit overview..." })
          : addOverviewLabel,
        hashKey: "description",
        onClick: () => {
          // Overview is edited on the page. Release the panel's focus trap
          // before moving keyboard focus into the inline editor.
          designPanelDisclosure.onClose()
          requestAnimationFrame(() =>
            requestAnimationFrame(() =>
              requestCoverPageInlineSectionEdit(
                CoverPagePanelSection.Description
              )
            )
          )
        }
      },
      ...(!isCollection
        ? [
            {
              itemKey: "add-steps-to-preview",
              icon: "plus",
              label: addPreviewLabel,
              panelRoute: "/preview",
              hashKey: "preview"
            } satisfies AugmentationPanelItemProps
          ]
        : [])
    ],
    [
      resource?.description,
      isCollection,
      t,
      addOverviewLabel,
      addPreviewLabel,
      designPanelDisclosure
    ]
  )

  return (
    <CoverPagePanelSectionBlock
      heading={t("panel_sections.content", { defaultValue: "Content" })}
      sectionKey="header"
      items={items}
    />
  )
}
